module.exports = __webpack_public_path__ + "static/media/warning-icon.a4a9804f.svg";